import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw0510Vo } from './kvaw0510.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0510（日報情報取得（実績））.xlsx
 */
@Injectable()
export class Kvaw0510Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0510';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 日報詳細情報（実績情報）を取得する
   *
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   */
  searchReportDetailActual(storeCode?: string, deliveryDate?: string): Observable<Kvaw0510Vo> {
    const query = {
      storeCode: storeCode,
      deliveryDate: deliveryDate,
    };

    return this.restApiService.search<Kvaw0510Vo>(Kvaw0510Service.TARGET, query);
  }

  /**
   * 過去日報詳細情報を取得する
   *
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   * @param shimeiCode 氏名コード
   */
  searchOldReportDetailActual(storeCode?: string, deliveryDate?: string, shimeiCode?: string): Observable<Kvaw0510Vo> {
    const query = {
      storeCode: storeCode,
      deliveryDate: deliveryDate,
      shimeiCode: shimeiCode,
    };

    return this.restApiService.search<Kvaw0510Vo>(Kvaw0510Service.TARGET, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0510.service.ts